import { useDeleteCompanyMember } from "@/api/console/companies/useDeleteCompanyMember";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import toast from "@/lib/toast";
import useMemberDialog from "@/src/console/(auth)/companies/[id]/_hooks/useMemberDialog";
import { SpinnerIosRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";

interface DeleteMemberDialogProps {
  companyId: number;
}

function DeleteMemberDialog({ companyId }: DeleteMemberDialogProps) {
  const { t } = useTranslation();
  const { type, member, resetDialog } = useMemberDialog();
  const memberId = member?.id ?? -1;
  const memberName = member?.name ?? "";

  const { trigger: deleteMember, isMutating } = useDeleteCompanyMember(
    memberId,
    {
      onSuccess: (data) => {
        resetDialog();
        toast.success(data.message);
        mutate(`/console/companies/${companyId}`);
      },
    },
  );

  return (
    <Dialog
      open={type === "delete"}
      onOpenChange={(open) => !open && resetDialog()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("delete-user")}</DialogTitle>
        </DialogHeader>
        <div className=" flex flex-col p-6">
          {`${memberName}? のアカウントを削除してもよろしいですか。\nこの操作は取り消せません。`}
          <div className=" flex flex-row mt-8 ml-auto space-x-4">
            <Button onClick={() => resetDialog()} variant="ghost">
              {t("cancel")}
            </Button>
            <Button
              LoadingComponent={<SpinnerIosRegular className="animate-spin" />}
              isLoading={isMutating}
              onClick={() => deleteMember()}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default DeleteMemberDialog;
